import React from "react";
import _Input from "../../generic/_Input";
import { PropTypes } from "prop-types";

const InputForm = ({ formik }) => {
  return (
    <div className="py-3 ease-in-out duration-300">
      <_Input
        title="Número de teléfono"
        id="phone"
        name="phone"
        type="text"
        placeholder={"+52 55 5555 5555"}
        value={formik.values.phone}
        pattern="^(?:52(?:1)?\d{10}|\d{10})$"
        onChange={(e) => {
          formik.setFieldValue("phone", e.target.value);
        }}
        required
        errors={formik.errors.phone ? formik.errors.phone : null}
        isError={formik.errors.phone ? true : false}
        isDisabled={formik.values.step === "VERIFIED"}
      />
    </div>
  );
};

InputForm.propTypes = {
  formik: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default InputForm;
